import { useViewTableData, skeletonFactory } from 'shared';
import { readers } from 'services';

const readersDummy = skeletonFactory.readers();

export function useReadersPaginated() {
  const {
    data: readersData,
    get: getReaders,
    deleteElements: deleteReaders,
    errorInfo: getDeleteErrorKey,
    setErrorInfo
  } = useViewTableData({
    service: readers,
    paginatedSkeleton: readersDummy
  });

  return {
    readers: readersData,
    errorInfo: getDeleteErrorKey,
    setErrorInfo,
    getReaders,
    deleteReaders
  };
}
